import Request from '../utilis/request';
import config from  '../config';
export function getUser(params){
    return Request({
        url: config.config.base_url+'/api/user',
        method: 'get',
        params:params
    })
}
export function getUsers(id){
    return Request({
        url: config.config.base_url+'/api/users/website/'+id,
        method: 'get',
    })
}
export function getAdminUsers(params){
    return Request({
        url: config.config.base_url+'/api/admin/users',
        method: 'get',
        params:params
    })
}
export function deleteUsers(id) {
    return Request({
        url: '/api/users/'+id,
        method: 'delete',
    })
}
export function exampleRequest() {
    return Request({
        url:config.config.base_url+'/api/examples',
        method:'get'
    })
}
export function login(data) {
    return Request({
        url: config.config.base_url+'/api/login',
        method: 'post',
        data: data
    })
}

export function logout() {
    return Request({
        url: config.config.base_url+'/api/logout',
        method: 'post',
    })
}

export function register(data) {
    return Request({
        url: config.config.base_url+'/api/register',
        method: 'post',
        data: data
    })
}

export function resend(data) {
    return Request({
        url: config.config.base_url+'/api/email/resend',
        method: 'POST',
        data: data
    })
}

export function update(data, id) {
    return Request({
        url: config.config.base_url+'/api/users/'+id,
        method: 'PUT',
        data: data
    })
}

export function getSessionKey() {
    return Request({
        url: config.config.base_url+'/session_key',
        method: 'get',
    })
}
export function getStats(params) {
    return Request({
        url: config.config.base_url+'/api/stats',
        method:'get',
        params:params
    })
}
export function sendRessetLink(data) {
    return Request({
        url: config.config.base_url+'/api/password/email',
        method:'POST',
        data: data
    })
}
export function getChartStats(params) {
    return Request({
        url: config.config.base_url+'/api/chart/stats',
        method:'get',
        params:params
    })
}
export function getChartLastOrders() {
    return Request({
        url: config.config.base_url+'/api/chart/last/orders',
        method:'get',
    })
}
export function resetPassword(data) {
    return Request({
        url: config.config.base_url+'/api/password/reset',
        method:'POST',
        data: data
    })
}
export function resendConfirmation(data) {
    return Request({
        url: config.config.base_url+'/api/email/resend',
        method:'POST',
        data: data
    })
}

export function deleteAccount(id) {
    return Request({
        url: config.config.base_url+'/api/users/'+id,
        method:'DELETE'
    })
}

export function requestInvitation(data) {
    return Request({
        url: config.config.base_url+'/api/request/invitation',
        method:'POST',
        data: data
    })
}
export function exportUsers(){
    return Request({
        url: config.config.base_url+'/api/export/users',
        method:'POST'
    })
}
export function updateCustomzation(data){
    return Request({
        url: config.config.base_url+'/api/update/customizable',
        method:'post',
        data: data
    })
}
export function updateShowDialog(){
    return Request({
        url: config.config.base_url+'/api/update/show/dialog',
        method:'post',
    })
}
export function dialogEmailDisplayed(){
    return Request({
        url: config.config.base_url+'/api/update/email/dialog',
        method:'post',
    })
}
